
import React from 'react';

export const ReportOverview: React.FC = () => {
  return (
    <section className="mb-12">
      <h2 className="text-2xl md:text-3xl font-bold mb-4">The AI Advantage</h2>
      <p className="text-lg text-white/80 mb-4">
        The legal industry has seen AI adoption nearly triple from 11% to 30% between 2023 and 2024. 
        But what does this mean for smaller practices with limited resources?
      </p>
      <p className="text-lg text-white/80 mb-4">
        This report provides exclusive insights into how small and mid-sized firms are using AI to 
        dramatically improve efficiency, client service, and profitability—often with better results 
        than their larger competitors.
      </p>
    </section>
  );
};

export default ReportOverview;
